/* ao-consent-sie — die letzte Du-Stelle in Shopifys Cookie-Dialog (30.08.2026)
 *
 * WAS NOCH ÜBRIG IST
 * Genau ein Satz: die Marketing-Beschreibung im Einstellungen-Dialog
 * („… und dir Werbung auf anderen Websites anzuzeigen"). Der ganze Shop siezt,
 * einschliesslich aller 56 Kundenbenachrichtigungen.
 *
 * WARUM NICHT ÜBER DIE ÜBERSETZUNGS-APP
 * Der Banner-Text selbst ist dort pflegbar, und Jonas hat ihn am 30.08. für beide Märkte
 * (Deutschland und Europäische Union) auf Sie gestellt — nachgeprüft am veröffentlichten
 * Theme, das dieses Skript gar nicht lädt, mit `?country=AT` auch für den EU-Markt.
 * Die frühere Banner-Regel ist damit erledigt und hier entfernt. Der Einstellungen-Dialog
 * hat in „Cookie-Banner-Felder" aber keine Entsprechung: Seine Texte kommen unverändert
 * aus Shopifys Übersetzung. Deshalb bleibt dieses eine Skript.
 *
 * MERKWÜRDIG, ABER SO GEMESSEN
 * Shopifys deutsche Fassung ist in sich uneinheitlich: Der Dialog siezt sonst durchgehend
 * („Sie haben die Kontrolle über Ihre Daten", „Erfahren Sie mehr…"), nur dieser eine Satz
 * duzt.
 *
 * SICHERHEITSNETZ
 * Ersetzt wird ein GANZER Textknoten und nur bei exakter Übereinstimmung. Ändert Shopify
 * seine Formulierung, greift die Regel nicht und der Originaltext bleibt stehen. Der
 * Ausfallmodus ist damit „Shopifys Text", nie „halb umgeschriebener Satz" — bei einem
 * rechtlich relevanten Hinweis der einzig vertretbare. Geändert wird ausschliesslich die
 * Anrede (dir→Ihnen), kein Aussagegehalt.
 *
 * ÜBERGANGSLÖSUNG
 * Mit dem Wechsel auf Usercentrics (ADR-0003) wird der Dialog ersetzt und dieses Skript
 * überflüssig. Dann bitte entfernen, statt es mitzuschleppen.
 */
(function () {
  'use strict';

  var ERSETZUNGEN = [
    {
      alt: 'Diese Cookies werden von uns und unseren Partnern verwendet, einschließlich ' +
           'Shopify, um Marketingbotschaften zu optimieren und dir Werbung auf anderen ' +
           'Websites anzuzeigen.',
      neu: 'Diese Cookies werden von uns und unseren Partnern verwendet, einschließlich ' +
           'Shopify, um Marketingbotschaften zu optimieren und Ihnen Werbung auf anderen ' +
           'Websites anzuzeigen.'
    }
  ];

  function umstellen(wurzel) {
    if (!wurzel) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT);
    var knoten = [];
    var n;
    while ((n = lauf.nextNode())) knoten.push(n);

    knoten.forEach(function (k) {
      var text = k.nodeValue;
      var kern = text.trim();
      if (!kern) return;
      for (var i = 0; i < ERSETZUNGEN.length; i++) {
        if (kern === ERSETZUNGEN[i].alt) {
          // Ersetzt wird im Originalstring, damit umgebender Weissraum erhalten bleibt.
          k.nodeValue = text.replace(ERSETZUNGEN[i].alt, ERSETZUNGEN[i].neu);
          return;
        }
      }
    });
  }

  function durchgang() {
    // Nur noch der Einstellungen-Dialog; das Banner kommt seit 30.08. bereits gesiezt
    // aus der Übersetzungs-App.
    umstellen(document.getElementById('shopify-pc__prefs'));
  }

  /* Der Einstellungen-Dialog entsteht erst beim Klick auf „Einstellungen verwalten".
     Deshalb ein Beobachter statt eines einmaligen Laufs — gedrosselt, damit er nicht bei
     jeder Fremd-Mutation der Seite arbeitet. */
  var geplant = false;
  function anstossen() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      durchgang();
    });
  }

  function start() {
    durchgang();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(anstossen).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
